import { ERoute, TRoute } from '../../types/route';

export const getCurrentOpenedChatId = (
  currentRoute: TRoute,
  nextRoute: TRoute,
  notClearCurrentOpenedChatId: boolean | undefined,
  currentOpenedChatId: string | null,
) => {
  if (currentRoute === ERoute.Messages && nextRoute !== ERoute.Messages) {
    return null;
  }

  if (notClearCurrentOpenedChatId && currentOpenedChatId) {
    return currentOpenedChatId;
  }

  return null;
};
